import CopyModal from '@atlassian/jira-copy-filters-modal/src/index.tsx';
import type { OperationModalProps } from '@atlassian/jira-directory-base/src/model/index.tsx';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { closeCopyFilterModal } from '../../../state/actions/copy-filter-modal/index.tsx';
import { isFavorite } from '../../../state/selectors/filters/index.tsx';
import type { State } from '../../../state/types.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToPropsOld = (state: State, ownProps: OperationModalProps<Record<any, any>>) => ({
	id: ownProps.entityId,
	isFavourite: isFavorite(state, ownProps.entityId),
	onCancel: ownProps.onCancel,
	onInitiateSuccess: () => {
		ownProps.onDialogShown();
	},
	onDataRetrieveFailed: () => {
		ownProps.onDataRetrieveFailed();
	},
	onCopied: () => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		ownProps.onUpdated();
	},
});

const mapStateToPropsNew = (
	initialState: State,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ownProps: OperationModalProps<Record<any, any>>,
) => {
	const onInitiateSuccess = () => {
		ownProps.onDialogShown();
	};
	const onDataRetrieveFailed = () => {
		ownProps.onDataRetrieveFailed();
	};
	const onCopied = () => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		ownProps.onUpdated();
	};
	return (_: State) => ({
		id: ownProps.entityId,
		onCancel: ownProps.onCancel,
		onInitiateSuccess,
		onDataRetrieveFailed,
		onCopied,
	});
};
export default connect(
	functionWithCondition(
		() => fg('fix_unstable_selector_in_filter_directory'),
		mapStateToPropsNew,
		// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
		mapStateToPropsOld,
	),
	{
		onCloseCopyFilterModal: closeCopyFilterModal,
	},
)(CopyModal);
